// CompraSueltaDialog.jsx
//
// #1887 · el diálogo GLOBAL de compra de jornadas sueltas (montado una vez en `App.js`). Lo abren el chip «Comprar jornada» de la
// banda de /turno y `jornadas-agotadas` (R71, R35, R61). Dentro de `PlanesYPago` (pantalla de bloqueo y «Elegir plan») la compra
// se hace en el mismo bloque, sin este diálogo. Misma forma que `CheckoutDialog` (pantalla completa en celular, zIndex sobre el
// bloqueo). La oferta y los documentos que se exigen se piden al abrirlo: nada se recuerda de antes.
// Cubre R33, R34, R71 — .claude/specs/jornada-suelta/
import { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogContent, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useCheckout from "../../hooks/useCheckout";
import { useOfertaSuelta } from "../../hooks/useJornadaEstado";
import { EVENTO_ABRIR_COMPRA } from "../../helpers/suelta-api";
import { botonGhostSx } from "../checkout/botonesSx";
import { Z_ENCIMA_DEL_GATE } from "../jornada/estilos";
import CompraSuelta from "./CompraSuelta";

const Contenido = ({ onCerrar }) => {
  const { oferta, cargada } = useOfertaSuelta();
  const { estado, cargar } = useCheckout();
  if (!cargada && !oferta) {
    return <Typography data-testid="suelta-cargando" sx={{ fontSize: 13, color: "var(--text-muted)", py: 2 }}>Cargando...</Typography>;
  }
  if (!oferta?.disponible) {
    return (
      <Box data-testid="suelta-no-disponible">
        <Typography sx={{ fontSize: 14, color: "var(--text-secondary)", mb: 1.5 }}>Las jornadas adicionales no están disponibles para tu cuenta por ahora.</Typography>
        <Button variant="outlined" onClick={onCerrar} sx={botonGhostSx}>Cerrar</Button>
      </Box>
    );
  }
  return <CompraSuelta oferta={oferta} estadoCheckout={estado} onRecargarCheckout={() => cargar()} onCancelar={onCerrar} />;
};

const CompraSueltaDialog = () => {
  const [abierto, setAbierto] = useState(false);
  const theme = useTheme();
  const pantallaCompleta = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const abrir = () => setAbierto(true);
    window.addEventListener(EVENTO_ABRIR_COMPRA, abrir);
    return () => window.removeEventListener(EVENTO_ABRIR_COMPRA, abrir);
  }, []);

  if (!abierto) return null;
  return (
    <Dialog
      open
      onClose={() => setAbierto(false)}
      fullScreen={pantallaCompleta}
      maxWidth="xs"
      fullWidth
      aria-label="Sumar jornada adicional"
      sx={{ zIndex: Z_ENCIMA_DEL_GATE }}
      PaperProps={{
        sx: {
          backgroundColor: "var(--bg-elevated)",
          backgroundImage: "none",
          border: pantallaCompleta ? 0 : "1px solid var(--border-soft)",
          borderRadius: pantallaCompleta ? 0 : "16px",
        },
      }}
    >
      <DialogContent sx={{ p: { xs: 2.5, sm: 3 } }}>
        <Contenido onCerrar={() => setAbierto(false)} />
      </DialogContent>
    </Dialog>
  );
};

export default CompraSueltaDialog;
